import { useRef } from "react";
import Form from "react-bootstrap/Form";
import { Formik, FormikProps } from "formik";
import * as Yup from "yup";

//App
import {
    SettingFormProps,
} from "../../../types/setting";

import {
    TextField,
    Chip,
} from "../../common/VFX-UI";

//Common
import FormBackGround from "../../common/Forms/FormBackGround/FormBackGround";
import FormHeader from "../../common/Forms/FormHeader/FormHeader";
import ActionBar from "../../common/ActionBar/ActionBar";
import { EMPTY_GUID } from "../../../utility/constants/constants";

const validationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required").max(250, "Max 250 characters are allowed."),
    description: Yup.string().required("Description is required").max(1500, "Max 1500 characters are allowed."),
    value: Yup.string().required("Setting value is required"),
});

const SettingForm = (props: SettingFormProps) => {
    const { status, initialVal, onClose, handleOnSubmit } = props;
    const formRef = useRef<FormikProps<any>>(null);

    const saveInput = () => {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    };

    return (
        <FormBackGround>
            <FormHeader title={initialVal.id !== EMPTY_GUID ? "Edit Setting" : "New Setting"} onClose={onClose} />
            <Formik
                onSubmit={handleOnSubmit}
                initialValues={initialVal}
                validationSchema={validationSchema}
                innerRef={formRef}
            >
                {({ values }) => (
                    <Form noValidate>
                        <div className="d-flex justify-content-end mb-3 me-3">
                            <Chip label={values.isActive ? "Active" : "Inactive"} />
                        </div>
                        <TextField label="Name" type="text" name="name" />
                        <TextField label="Description" type="textarea" name="description" />
                        <TextField label="Setting Value" type="text" name="value" />
                        <TextField label="Display Order" type="text" name="sortValue" />
                        <ActionBar
                            submitHandler={saveInput}
                            cancelHandler={onClose}
                            submitText="Submit"
                            cancelText="Cancel"
                            isLoading={status === "pending"}
                        ></ActionBar>
                    </Form>
                )}
            </Formik>
        </FormBackGround>
    );
};

export default SettingForm;
